import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import { HelpCircle } from 'react-feather';

import { Tooltip, IconButton as MuiIconButton } from '@material-ui/core';

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

interface IProps {
  helpRoute: string;
}

const HelpButton: React.FC<IProps> = ({ helpRoute }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(helpRoute);
  };

  return (
    <Tooltip title="Help">
      <IconButton aria-owns="menu-appbar" aria-haspopup="true" onClick={handleClick} color="inherit">
        <HelpCircle />
      </IconButton>
    </Tooltip>
  );
};

export default HelpButton;
